<template>
	<div class="centerWidth">
		<div class="gaokao-nav">
			<span @click="goMyCenter">个人中心 ></span>
			<span @click="goBack">升学途径选科测评 ></span>
			<span>开始测试</span>
			<!-- <el-button type="primary" style="margin-left: 20px;" @click="ceshiOption()">选择</el-button> -->
		</div>
		<way-testa @next="handleNext" :question.sync="baseInfoQuestion" v-show="tabId === 1"></way-testa>
		<way-testb @next="handleNext" @prev="handlePrev" :question.sync="healthQuestion" v-show="tabId === 2"></way-testb>
		<way-testc @next="handleNext" @prev="handlePrev" :question.sync="familyQuestion" v-show="tabId === 3"></way-testc>
		<way-testd @next="handleNext" @prev="handlePrev" :question.sync="abilityQustion" v-show="tabId === 4"></way-testd>
		<way-teste @submitEvalution="handleSubmit" @prev="handlePrev" :question.sync="intentionQuestion" :isSub.sync="noticeVisible" v-show="tabId === 5"></way-teste>
		<!-- 5.30 -->
		<div class="ptpopupTc flexCenter" v-show="isJiaIng">
			<div class="ptpotxt">
				<div class="ptadiva" id="myChartYuan"></div>
				<p>请稍等,正在为您生成报告...</p>
			</div>
		</div>
	</div>
</template>

<script>
import wayTesta from './wayTestA.vue';
import wayTestb from './wayTestB.vue';
import wayTestc from './wayTestC.vue';
import wayTestd from './wayTestD.vue';
import wayTeste from './wayTestE.vue';

export default {
	components: {
		wayTesta,
		wayTestb,
		wayTestc,
		wayTestd,
		wayTeste
	},
	data() {
		return {
			ratioTime:null,
			isJiaIng: false,
			tabId: 1,
			question: [],
			// 基本信息
			baseInfoQuestion: [],
			// 个人条件
			healthQuestion: [],
			// 家庭条件
			familyQuestion: [],
			// 个人能力
			abilityQustion: [],
			// 个人意愿
			intentionQuestion: [],
			// 是否显示提示
			noticeVisible: false
		};
	},
	watch: {
		tabId() {
			document.querySelector('body').scrollTo(0, 0);
			window.scrollTo(0, 0);
		}
	},
	created() {
		this.getQuestion();
	},
	beforeDestroy() {
		if (this.ratioTime) {
			clearTimeout(this.ratioTime);
			this.ratioTime = null;
		}
	},
	mounted() {
		this.drawLineB(0);
	},
	methods: {
		drawLineB(nub) {
			var that = this;
			console.log('nub', nub);
			const myChart = this.$echarts.init(document.getElementById('myChartYuan'));
			myChart.setOption({
				color: ['#feb9a7', '#3171ff00'],
				tooltip: {
					trigger: 'item',
					show: false
				},
				graphic: {
					type: 'text',
					left: 'center',
					top: 'center',
					style: {
						text: nub + '%',
						textAlign: 'center',
						fill: '#7ac8fd',
						fontSize: 24
					}
				},
				legend: {
					top: '0%',
					left: 'center'
				},
				series: [
					{
						type: 'pie',
						radius: ['55%', '65%'],
						avoidLabelOverlap: false,
						hoverAnimation: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '40',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: true
						},
						data: [
							{
								value: nub,
								name: ''
							},
							{
								value: 100 - nub,
								name: ''
							}
						]
					}
				]
			});
			if (nub > 0 && nub < 100) {
				that.ratioTime = setTimeout(() => {
					var dd = nub;
					if (dd === 99) {
						dd = 99;
					} else if (dd > 80) {
						dd = dd + 1;
					} else if (dd > 60) {
						dd = dd + 5;
					} else {
						dd = dd + 10;
					}
					that.drawLineB(dd);
				}, 1000);
			} else {
				if (that.ratioTime) {
					clearTimeout(that.ratioTime);
					that.ratioTime = null;
				}
			}
		},
		// 个人中心
		goMyCenter() {
			this.$router.push('/myIndex');
		},
		// 返回上一级
		goBack() {
			this.$router.go(-1);
		},
		// 获取题目
		getQuestion() {
			this.$api.getEvaluationQuestion(this.$route.query).then(res => {
				const questionList = res.data.map(a => {
					a.Title = a.Title.replaceAll('##', '');
					a.Content = '';
					a.Option = '';
					a.OptionList = [];
					a.ContentList = [];
					const arr = [];
					if (a.Type === 3 && a.AnswerCount > 1) {
						for (let i = 0; i < a.AnswerCount; i++) {
							arr.push('');
						}
						a.ContentList = arr;
					}
					a.notEmpty = true;
					return a;
				});
				this.question = questionList;
				this.baseInfoQuestion = questionList.filter(a => a.Category === '基本信息');
				this.healthQuestion = questionList.filter(a => a.Category === '身体条件');
				this.familyQuestion = questionList.filter(a => a.Category === '家庭条件');
				this.abilityQustion = questionList.filter(a => a.Category === '个人能力');
				this.intentionQuestion = questionList.filter(a => a.Category === '个人意愿');
				console.log('questionList',questionList);
			});
		},
		ceshiOption(){
			console.log('this.baseInfoQuestion',this.baseInfoQuestion);
			if(this.baseInfoQuestion.length>0){
				this.baseInfoQuestion = this.baseInfoQuestion.map(a=>{
					if(a.Type==1){
						a.Option='A';
					}
					if(a.Type==2){
						a.OptionList = a.AnswerList;
					}
					if(a.Type==3){
						a.Content='2022-07-04';
					}
					
					return a;
				}); 
			}
			if(this.healthQuestion.length>0){
				this.healthQuestion = this.baseInfoQuestion.map(a=>{
					if(a.Type==1){
						a.Option='A';
					}
					if(a.Type==2){
						a.OptionList = a.AnswerList;
					}
					if(a.Type==3){
						a.Content='2022-07-04';
					}
					
					return a;
				}); 
			}
			if(this.familyQuestion.length>0){
				this.familyQuestion = this.baseInfoQuestion.map(a=>{
					if(a.Type==1){
						a.Option='A';
					}
					if(a.Type==2){
						a.OptionList = a.AnswerList;
					}
					if(a.Type==3){
						a.Content='2022-07-04';
					}
					
					return a;
				}); 
			}
			if(this.abilityQustion.length>0){
				this.abilityQustion = this.baseInfoQuestion.map(a=>{
					if(a.Type==1){
						a.Option='A';
					}
					if(a.Type==2){
						a.OptionList = a.AnswerList;
					}
					if(a.Type==3){
						a.Content='2022-07-04';
					}
					
					return a;
				}); 
			}
			if(this.intentionQuestion.length>0){
				this.intentionQuestion = this.baseInfoQuestion.map(a=>{
					if(a.Type==1){
						a.Option='A';
					}
					if(a.Type==2){
						a.OptionList = a.AnswerList;
					}
					if(a.Type==3){
						a.Content='2022-07-04';
					}
					
					return a;
				}); 
			}
			
		},
		// 下一步
		handleNext() {
			if (this.tabId < 5) {
				this.tabId += 1;
			}
		},
		// 上一步
		handlePrev() {
			if (this.tabId > 1) {
				this.tabId -= 1;
			}
		},
		// 保存测评
		handleSubmit() {
			if (!this.validateModel()) {
				return;
			}
			const model = {
				EvaluationId: Number(this.$route.query.id),
				Key: this.$route.query.key
			};
			model.Question = [...this.baseInfoQuestion, ...this.healthQuestion, ...this.familyQuestion, ...this.abilityQustion, ...this.intentionQuestion].map(a => {
				console.log('a', a);
				const obj = {
					QuestionId: a.Id,
					Type: a.Type,
					Content: a.Content,
					Option: a.Option
				};
				if (a.Type === 2) {
					obj.Option = a.OptionList.join(',');
				}
				if (a.Type === 3 && a.AnswerCount > 1) {
					obj.Content = a.Id === 7 ? `${a.ContentList[0][1]},${a.ContentList[1]}` : a.ContentList.join(',');
				}
				return obj;
			});
			// const loading = this.$loading({
			// 	lock: true
			// });
			this.drawLineB(10);
			this.$api.saveEvaluation(model).then(res => {
				this.drawLineB(100);
				setTimeout(() => {
					this.isJiaIng = false;
					setTimeout(() => {
						this.drawLineB(0);
						this.noticeVisible = true;
						setTimeout(() => {
							this.$router.push('/report');
							// loading.close();
						}, 3000);
					}, 300);
				}, 500);
			});
		},
		// 检查是否有题目未完成
		validateModel() {
			const noticeArr = [];
			if (this.baseInfoQuestion.some(a => !a.Content && !a.Option && a.OptionList.length === 0 && a.ContentList.length === 0)) {
				const emptyArr = this.baseInfoQuestion.filter(a => !a.Content && !a.Option && a.OptionList.length === 0 && a.ContentList.length === 0);
				this.baseInfoQuestion = this.baseInfoQuestion.map(a => {
					a.notEmpty = !emptyArr.some(b => b.Id === a.Id);
					return a;
				});
				noticeArr.push('基本信息');
				// this.$util.showError('基本信息中有未完成的题目，请完成后提交');
				// return false;
			}
			if (this.healthQuestion.some(a => !a.Content && !a.Option && a.OptionList.length === 0)) {
				const emptyArr = this.healthQuestion.filter(a => !a.Content && !a.Option && a.OptionList.length === 0);
				this.healthQuestion = this.healthQuestion.map(a => {
					a.notEmpty = !emptyArr.some(b => b.Id === a.Id);
					return a;
				});
				noticeArr.push('个人条件');
				// this.$util.showError('个人条件中有未完成的题目，请完成后提交');
				// return false;
			}
			if (this.familyQuestion.some(a => !a.Content && !a.Option && a.OptionList.length === 0)) {
				const emptyArr = this.familyQuestion.filter(a => !a.Content && !a.Option && a.OptionList.length === 0);
				this.familyQuestion = this.familyQuestion.map(a => {
					a.notEmpty = !emptyArr.some(b => b.Id === a.Id);
					return a;
				});
				noticeArr.push('家庭条件');
				// this.$util.showError('家庭条件中有未完成的题目，请完成后提交');
				// return false;
			}
			if (this.abilityQustion.some(a => !a.Content && !a.Option && a.OptionList.length === 0)) {
				const emptyArr = this.abilityQustion.filter(a => !a.Content && !a.Option && a.OptionList.length === 0);
				this.abilityQustion = this.abilityQustion.map(a => {
					a.notEmpty = !emptyArr.some(b => b.Id === a.Id);
					return a;
				});
				noticeArr.push('个人能力');
				// this.$util.showError('个人能力中有未完成的题目，请完成后提交');
				// return false;
			}
			if (this.intentionQuestion.some(a => !a.Content && !a.Option && a.OptionList.length === 0)) {
				const emptyArr = this.intentionQuestion.filter(a => !a.Content && !a.Option && a.OptionList.length === 0);
				this.intentionQuestion = this.intentionQuestion.map(a => {
					a.notEmpty = !emptyArr.some(b => b.Id === a.Id);
					return a;
				});
				noticeArr.push('个人意愿');
				// this.$util.showError('个人意愿中有未完成的题目，请完成后提交');
				// return false;
			}
			if (noticeArr.length > 0) {
				this.$util.showError(`${noticeArr.join(',')}中有未完成的题目，请完成后提交`);
				return false;
			}
			return true;
		}
	}
};
</script>

<style scoped></style>
